import { Routes, Route } from "react-router-dom";

import Login from "./login";

export default function Users() {
  return (
    <Routes>
      <Route path="/" Component={Login} />
    </Routes>
  );
}
